{
  "enum": {
    "J5ClientV1DiagramVariant": {
      "DARK": "Dark",
      "LIGHT": "Light",
      "UNSPECIFIED": "Unspecified"
    },
    "J5ClientV1ListRequestSortFieldDirection": {
      "ASC": "Ascending",
      "DESC": "Descending",
      "UNSPECIFIED": "Unspecified"
    }
  }
}